'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const ContentByTypeMap=new Map([
[FatigueMeterType.Aviation,{
abbreviation:'afm',
brandLogoImageUrl:'/images/AFMLogo.svg',
headerIconUrl:'/images/AFMicon.svg',
faviconUrl:'/afm-favicon.ico',
fullName:'Aviation',
fullAppTitle:'Aviation Fatigue Meter Dashboard',
defaultFeature:'fdc.features.emiratesDashboard',
personTypeLabelSingular:'Crew Member',
personTypeLabelPlural:'Crew Members',
heatmapButtonLabel:'Heatmap',
tripLabelPlural:'Flights',
fleetInsightPageTitle:'Fleet Insight',
pdfFooterLogoFilename:'AFMicon.png',
pdfCoverLogoFilename:'AFMReportLogo.png'}],


[FatigueMeterType.Workforce,{
abbreviation:'wfm',
brandLogoImageUrl:'/images/WFMLogo.svg',
headerIconUrl:'/images/WFMicon.svg',
faviconUrl:'/wfm-favicon.ico',
fullName:'Workforce',
fullAppTitle:'Workforce Fatigue Meter',
defaultFeature:'fdc.features.dashboard',
personTypeLabelSingular:'Worker',
personTypeLabelPlural:'Workers',
heatmapButtonLabel:'Heatmap',
tripLabelPlural:'Trips',
fleetInsightPageTitle:'Team Insight',
pdfFooterLogoFilename:'WFMicon.png',
pdfCoverLogoFilename:'WFMReportLogo.png'}],


[FatigueMeterType.Trucking,{
abbreviation:'tfm',
brandLogoImageUrl:'/images/TFMLogo.svg',
headerIconUrl:'/images/TFMicon.svg',
faviconUrl:'/tfm-favicon.ico',
fullName:'Trucking',
fullAppTitle:'Trucking Fatigue Meter',
defaultFeature:'fdc.features.dashboard',
personTypeLabelSingular:'Driver',
personTypeLabelPlural:'Drivers',
heatmapButtonLabel:'Boards',
tripLabelPlural:'Driving',
fleetInsightPageTitle:'Fleet Insight',
pdfFooterLogoFilename:'TFMicon.png',
pdfCoverLogoFilename:'TFMReportLogo.png'}]]);let




FatigueMeterTypeContentProviderService=function(_BaseService){_inherits(FatigueMeterTypeContentProviderService,_BaseService);
function FatigueMeterTypeContentProviderService($window,$timeout){_classCallCheck(this,FatigueMeterTypeContentProviderService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this._$window=$window;
_this._$timeout=$timeout;

_this.updateProvidedContentToType(null);return _this;
}FatigueMeterTypeContentProviderService.prototype.

updateProvidedContentToType=function updateProvidedContentToType(newFatigueMeterType){
this._fatigueMeterType=newFatigueMeterType||FatigueMeterTypeContentProviderService.getDefaultType(_.get(this,'_$window.location.hostname',''));
this.providedContent=ContentByTypeMap.get(this._fatigueMeterType);
};FatigueMeterTypeContentProviderService.





































































getDefaultType=function getDefaultType(){let hostname=arguments.length>0&&arguments[0]!==void 0?arguments[0]:'';

return FatigueMeterType.Aviation;







};_createClass(FatigueMeterTypeContentProviderService,[{key:'fatigueMeterType',get:function(){return this._fatigueMeterType}},{key:'faviconUrl',get:function(){return _.get(this.providedContent,'faviconUrl')}},{key:'headerIconUrl',get:function(){return _.get(this.providedContent,'headerIconUrl')}},{key:'fullName',get:function(){return _.get(this.providedContent,'fullName')}},{key:'fullAppTitle',get:function(){return _.get(this.providedContent,'fullAppTitle')}},{key:'brandLogoImageUrl',get:function(){return _.get(this.providedContent,'brandLogoImageUrl')}},{key:'abbreviation',get:function(){return _.get(this.providedContent,'abbreviation')}},{key:'defaultFeature',get:function(){return _.get(this.providedContent,'defaultFeature')}},{key:'personTypeLabelSingular',get:function(){return _.get(this.providedContent,'personTypeLabelSingular')}},{key:'personTypeLabelPlural',get:function(){return _.get(this.providedContent,'personTypeLabelPlural')}},{key:'heatmapButtonLabel',get:function(){return _.get(this.providedContent,'heatmapButtonLabel')}},{key:'fleetInsightPageTitle',get:function(){return _.get(this.providedContent,'fleetInsightPageTitle')}},{key:'pdfFooterLogoFilename',get:function(){return _.get(this.providedContent,'pdfFooterLogoFilename')}},{key:'pdfCoverLogoFilename',get:function(){return _.get(this.providedContent,'pdfCoverLogoFilename')}},{key:'tripLabelPlural',get:function(){return _.get(this.providedContent,'tripLabelPlural')}}],[{key:'ContentByTypeMap',get:function(){return ContentByTypeMap}},{key:'DefaultContent',get:function(){return ContentByTypeMap.get(FatigueMeterTypeContentProviderService.getDefaultType())}}]);return FatigueMeterTypeContentProviderService}(BaseService);

module.exports=FatigueMeterTypeContentProviderService;
//# sourceMappingURL=fatigueMeterTypeContentProviderService.js.map
